import styled from "styled-components";
import SearchIcon from "../../../assets/search-solid.svg";

export const Container = styled.div`
  width: 20%;
  min-width: 250px;
  height: 100%;
  background: #e3f0f8;
  display: flex;
  align-items: flex-start;
  flex-direction: column;

  ul {
    padding: 2rem;
    list-style: none;
    width: 100%;

    li {
      padding: 1rem;
      background: #ffffff;
      display: flex;
      width: 100%;
      border-radius: 5px;
      align-items: center;
      cursor: pointer;
      margin-bottom: 1rem;
      position: relative;

      &.selected {
        position: relative;

        &:before {
          content: "";
          position: absolute;
          background: #1ab394;
          height: 100%;
          width: 5px;
          left: 0;
          border-radius: 5px 0 0 5px;
        }
      }

      h2 {
        font-size: 1.4rem;
        margin-left: 1rem;
        font-weight: 600;

        small {
          display: block;
          font-weight: normal;
          color: rgba(0, 0, 0, 0.5);

          &.online {
            color: #0f715e;
            font-weight: bold;
          }
        }
      }
    }

    .pending-messages {
      margin-left: auto;
      width: 2rem;
      height: 2rem;
      min-width: 2rem;
      background: #18b7fa;
      border-radius: 50%;
      color: #fff;
      font-size: 1.2rem;
      font-weight: bold;
      justify-content: center;
      align-items: center;
      display: flex;
    }
  }
`;

export const Head = styled.div`
  padding: 2rem;
  align-items: center;
  justify-content: center;
  display: flex;
  width: 100%;
  flex-direction: column;
  border-bottom: thin solid rgba(255, 255, 255, 0.5);

  form {
    width: 100%;
  }

  input {
    padding: 1.5rem 3rem;
    padding-left: 5rem;
    width: 100%;
    border-radius: 50px;
    border: 0;
    background: url(${SearchIcon});
    background-repeat: no-repeat;
    background-size: 20px;
    background-position: 15px center;
    background-color: #ffffff;

    text-transform: none !important;
    box-shadow: none !important;

    ::-webkit-input-placeholder {
      text-transform: none !important;
    }
    ::-moz-placeholder {
      text-transform: none !important;
    }
    :-ms-input-placeholder {
      text-transform: none !important;
    }
    :-moz-placeholder {
      text-transform: none !important;
    }
  }

  h1 {
    font-size: 1.8rem;
    margin-top: 0.5rem;
    font-weight: 600;
  }

  p {
    font-size: 1.3rem;
    color: rgba(0, 0, 0, 0.6);
    margin-top: 0.2rem;
  }
`;

export const Avatar = styled.div`
  width: 50px;
  height: 50px;
  min-width: 50px;
  background-color: #f0f0f0;
  border-radius: 50%;
  overflow: hidden;
  position: relative;

  img {
    max-width: 100%;
  }
`;

export const Close = styled.div`
  width: 50px;
  height: 50px;
  background: #e3f0f8;
  border-radius: 5px 0 0 5px;
  position: absolute;
  left: -5rem;
  -webkit-box-shadow: -5px 0px 5px 0px rgba(0, 0, 0, 0.15);
  -moz-box-shadow: -5px 0px 5px 0px rgba(0, 0, 0, 0.15);
  box-shadow: -5px 0px 5px 0px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  color: rgba(0, 0, 0, 0.4);
`;

export const Settings = styled.div`
  width: 50px;
  height: 50px;
  top: 54px;
  background: #e3f0f8;
  border-radius: 5px 0 0 5px;
  position: absolute;
  left: -5rem;
  -webkit-box-shadow: -5px 0px 5px 0px rgba(0, 0, 0, 0.15);
  -moz-box-shadow: -5px 0px 5px 0px rgba(0, 0, 0, 0.15);
  box-shadow: -5px 0px 5px 0px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  color: rgba(0, 0, 0, 0.4);
`;



// WEBPACK FOOTER //
// ./src/components/ChatContainer/Users/styles.js